<template>
  <div class="Companies-list ">
    <div class="sec-wrapper d-flex align-items-center mb-4">
      <h2 id="famous-companies " class="section-title"> شركات التشغيل</h2>
      <div class="blue-line"></div>
    </div>
    <div class="Companies-cards mt-3">
      <b-row class="align-items-center">
        <b-col md="3" class="mb-5">
          <label class="text-start"> بحث عن طريق الأسم  </label>

          <b-form-input
            v-model="searchData.name"
            type="text"
            class="form-input"
            placeholder="بحث "
          />
        </b-col>
        <b-col md="3" class="mb-5">
          <label class="text-start"> بحث عن طريق رقم السجل </label>

          <b-form-input
            v-model="searchData.commercial_register_num"
            type="text"
            class="form-input"
            placeholder="بحث عن طريق رقم السجل "
          />
        </b-col>

        <b-col md="2" class="mb-5">
          <label class="text-start">تصنيف حسب المدينه</label>
          <select class="form-select" aria-label="اختر المدينة"    v-model="searchData.city_id">
            <option selected>اختر المدينة </option>
            <option value="1">Riyadh</option>
          </select>
        </b-col>

        <b-col  md="1">
          <button  class="btn btn-outline-primary w-1" @click="searchData={}"> مسح</button>
        </b-col>

        <vue3-datatable
          skin="bh-table-striped bh-table-hover bh-table-bordered bh-table-compact"
          paginationInfo=""
          :rows="CompaniesList.companies"
          :columns="columns"
          :showPageSize="false"
          :totalRows="CompaniesList.count"
          showNumbers
          pagination
          :isServerMode="true"
          @change="changeServer"
        >
          <template #image="data">
            <div v-if="data.value.image">
              <router-link
                :to="{
                  name: 'show-ministry-company',
                  params: { id: data.value.id },
                }"
              >
              <img
                v-if="data.value.image.url"
                :src="data.value.image.url"
                width="120"
              />
              </router-link>
            </div>
          </template>
          <template #actions="data">
            <div class="flex gap-4">
              <div class="icon theme-color">
                <i class="fas fa-phone-volume"></i>
              </div>
              <router-link
                :to="{
                  name: 'show-ministry-company',
                  params: { id: data.value.id },
                }"
              >
                <vue-feather size="16" stroke="blue" type="eye"></vue-feather>
              </router-link>
            </div>
          </template>
          <template #certificates="data">
            <div v-if="data.value.certificates">
              <span v-if="data.value.certificates.length">{{
                data.value.certificates.length
              }}</span>
            </div>
          </template>
        </vue3-datatable>
      </b-row>
    </div>
  </div>
</template>

  <script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";

export default {
  components: { Vue3Datatable },
  name: "CompaniesList",
  props: {
    CompaniesList: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      searchData: {},
      APIURL: "companies",
      editComponent: "edit-company",
      viewContent: true,
      type: "page",
      selectedSearchOption: "name",
    };
  },
  watch: {
  'searchData.name'(newName, oldName) {
    if (newName !== oldName) {
      this.$emit("search", this.searchData);
    }
  },
  'searchData.commercial_register_num'(newCommercialNum, oldCommercialNum) {
    if (newCommercialNum !== oldCommercialNum) {
      this.$emit("search", this.searchData);
    }
  },
  'searchData.category'(newCategory, oldCategory) {
    if (newCategory !== oldCategory) {
      this.$emit("search", this.searchData);
    }
  },
  'searchData.city_id'(newCityId, oldCityId) {
    if (newCityId !== oldCityId) {
      this.$emit("search", this.searchData);
    }
  },
},



  computed: {
    filteredCompanies() {
      // Filter Companies based on the search input
      if (!this.search) {
        return this.CompaniesList;
      }

      const searchTerm = this.search.toLowerCase();
      return this.CompaniesList.filter((employee) =>
        this.columns.some((column) => {
          const key = column.key;
          const value = employee[key];
          return value && value.toLowerCase().includes(searchTerm);
        })
      );
    },
  },
  methods: {

    changeServer({ current_page }) {
      this.$emit("page-change", current_page);
    },
  },
};
</script>

  <style lang="scss">
  .bh-table-responsive table.bh-table-bordered tbody tr td{
    background: #f8f9fa;
    border-color:#ededed;
  }
.bh-table-responsive table.bh-table-bordered thead tr th{
    background: #ededed;
  }
  label{
    display: flex !important;
  }
</style>
